import { render, staticRenderFns } from "./group_activity_card.vue?vue&type=template&id=f7f034f6&vue3"
import script from "./group_activity_card.vue?vue&type=script&lang=js&vue3"
export * from "./group_activity_card.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports